import React, { createContext, useContext, useState, useEffect } from 'react';

const NotificationContext = createContext();

export const NotificationProvider = ({ children }) => {
  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);

  // Mock notifications - replace with real API calls
  useEffect(() => {
    const mockNotifications = [
      {
        id: 1,
        type: 'share',
        title: 'New share access',
        message: 'Someone viewed your shared entry "My Amazing Day"',
        timestamp: new Date(Date.now() - 2 * 60 * 60 * 1000),
        read: false
      },
      {
        id: 2,
        type: 'reminder',
        title: 'Daily writing reminder',
        message: "Don't forget to write in your diary today!",
        timestamp: new Date(Date.now() - 24 * 60 * 60 * 1000),
        read: false
      },
      {
        id: 3,
        type: 'milestone',
        title: 'Writing streak!',
        message: 'Congratulations! You have a 7-day writing streak.',
        timestamp: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000),
        read: true
      }
    ];
    
    setNotifications(mockNotifications);
    setUnreadCount(mockNotifications.filter(n => !n.read).length);
  }, []);

  const markAsRead = (notificationId) => {
    setNotifications(prev => 
      prev.map(notification => 
        notification.id === notificationId 
          ? { ...notification, read: true }
          : notification
      )
    );
    setUnreadCount(prev => Math.max(0, prev - 1));
  };

  const markAllAsRead = () => {
    setNotifications(prev => prev.map(n => ({ ...n, read: true })));
    setUnreadCount(0);
  };

  return (
    <NotificationContext.Provider value={{
      notifications,
      unreadCount,
      markAsRead,
      markAllAsRead
    }}>
      {children}
    </NotificationContext.Provider>
  );
};

export const useNotifications = () => {
  const context = useContext(NotificationContext);
  if (!context) {
    throw new Error('useNotifications must be used within a NotificationProvider');
  }
  return context;
};
